<div class="language-selector-container">
  <select class="language-select toolbar-item" [(ngModel)]="selectedLocale" (ngModelChange)="changeLocale($event)">
    <option *ngFor="let locale of locales" [ngValue]="locale">
      {{ locale.language }} {{ locale.countryCode }}
    </option>
  </select>
</div>
